module.exports = __webpack_public_path__ + "img/arnandhita-agiel-untitled.8835ca4.jpg";